import Vue from 'vue'
import vuex from 'vuex';
import App from './App.vue';
import Meta from 'vue-meta';
import createRouter from './router.js'
import { createStore } from './store'
import vueRouter from "vue-router";
import Econfig from './config.js'
import ElementUI from 'element-ui';
import './assets/css/element.css'
Vue.config.productionTip = false;
// import { ArtTextDown } from 'art-ui';
import md5 from 'js-md5';

// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入折线
require('echarts/lib/chart/line');
// 引入饼状图
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/legend')
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/dataZoom');

Vue.prototype.$echarts = echarts;
Vue.prototype.$md5 = md5;
Vue.prototype.$Econfig = Econfig.Econfig;

// import Vant from 'vant'
//import { nextTick } from 'process';
// Vue.use(ArtPicture3)
// Vue.use(ArtTextDowm)
// console.log('---->', ArtTextDown)
// Vue.use(ArtTextDown)
// Vue.use(Vant)
Vue.use(ElementUI)
Vue.use(vueRouter);
Vue.use(vuex);
Vue.use(Meta);

// 解决报错
// const originalPush = vueRouter.prototype.push
// const originalReplace = vueRouter.prototype.replace
// // push
// vueRouter.prototype.push = function push (location, onResolve, onReject) {
// if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
// return originalPush.call(this, location).catch(err => err)
// }
// // replace
// vueRouter.prototype.replace = function push (location, onResolve, onReject) {
// if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
// return originalReplace.call(this, location).catch(err => err)
// }

// // 后台管理name
//  const adminName = ['logo','adminiStrator', 'announcement', 'focusMap', 'focusMapAdd', 'userServices', 'specialFeatures', 'specialFeaturesAdd', 'previewBoutique', 'previewBoutiqueAdd', 'transactionBoutique', 'transactionBoutiqueAdd', 'specialManagement', 'collectionManagement', 'collectionManagementAdd', 'shootingManagement', 'shootingManagementAdd', 'companyProfile', 'contactPage', 'physicalStoreDisplay', 'physicalStoreDisplayAdd', 'institutionalFramework', 'branchOffice', 'consultingFeedback', 'displaySettings']
import { addRouter } from '@/api/company/index.js'
import {webCheckType} from "@/api/auction";
import {awaitExpression} from "@babel/types";
import Cookies from "js-cookie";


export function createApp() {
    const router = createRouter()
    const store = createStore()

    const webCheck = async() =>{
        // let val = Cookies.get('_at_pt_0_');
        // let content = await webCheckType()
        return new Promise((resolve) => {
            resolve({status:200})
            // if(content){
            //     if (val) {
            //         //    如果接口返回data.status=405 执行退出登录操作
            //         resolve(content.data)
            //     }else{
            //         resolve({status:200})
            //     }
            // }else{
            //     resolve({status:200})
            // }
        })
        // return new Promise((resolve) => {
        //     resolve({status:200})
        // })
    }
    router.beforeEach(async (to, from, next) => {
        if(typeof window === 'undefined') {
            next();
            return
        }
        //判断是否在其他设备登录
       let val =  await webCheck();
       console.log(val)
        if (val && val.status == 405) {
          //  alert('您的账号正在其他设备登录，为了你的账号安全，本次登录已失效。您可以从新登录，建议您及时修改密码！')
            Vue.prototype.$confirm(val.notice, {
                confirmButtonText: '重新登录',
                // type: 'warning',
                center: true,
                showClose:false,
                showCancelButton:false,
            }).then(() => {
                //退出
                window.location.href = '//passport.artron.net/memCenter/logout?redirect='+encodeURIComponent(window.location.href)
               })
          }else{
            // 先检查sessionStorage中是否有数据，若存在数据则加载到vuex
            let redirectedFrom = to.path;
            let arr = redirectedFrom.split('/')
            if(to.meta.name === 'mechanism') {
                const createRoutr = await addRouter();
                const active =await createRoutr.data.list.filter(e => {
                    return e == to.path.split('/')[1]
                })
                if(!active.length) {
                    let newpar = /([a-zA-Z]+)-([0-9]+)/
                    let arr = redirectedFrom.split('/')
                    if (redirectedFrom && to.name != 'special_detail' && to.name != 'org_detail' && to.name != 'meeting_detail') {
                        let test1 = redirectedFrom.indexOf('PMH')
                        let test2 = redirectedFrom.indexOf('PZ')
                        let test3 = redirectedFrom.indexOf('sendInfor.php')
                        let test4 = redirectedFrom.indexOf('showpic.php')
                        let test5 = redirectedFrom.indexOf('morenews.php')
                        let test6 = redirectedFrom.indexOf('gongyue.php')
                        let test7 = to.fullPath.indexOf('introduce')
                        let test8 = redirectedFrom.indexOf('taipingyangguoji')
                        if(newpar.test(redirectedFrom)){
                            next('/org_detail/JG'+((arr[arr.length - 1] == '') ? arr[arr.length - 2] : arr[arr.length - 1]).split('-')[1])
                        }else if (test1 != -1 && test2 != -1) {
                            next('/special_detail'+((arr[arr.length - 1] == '') ? arr[arr.length - 2] : arr[arr.length - 1]))
                        } else if (test1 != -1) {
                            next('/meeting_detail'+((arr[arr.length - 1] == '') ? arr[arr.length - 2] : arr[arr.length - 1]))
                        }else if (test3 != -1) {
                            next('/sendInfor')
                        }else if (test4 != -1) {
                            next('/paimai-'+to.query.picid)
                        }else if (test5 != -1) {
                            next('/morenews/'+to.query.column_id)
                        }else if(test6 != -1){
                            next('/help/gongyue')
                        }else if(test7 != -1){
                            next('/help/introduce')
                        }else if(test8 != -1){
                            next()
                        }else{
                            next('/404')
                        }
                    }else{
                        next('/404')
                    }
                }else{
                    next()
                }
            }else if(to.path == '/help/introduce/html/introduce_brand.html'){
                next('/help/introduce')
            } else if(redirectedFrom.indexOf('minglu.php') != -1 || redirectedFrom.indexOf('christies2012') != -1){
                next('/404')
            } else if(redirectedFrom.indexOf('songpai') != -1){

                next('/'+arr[1]+'/collect?id=2')
            }else if(redirectedFrom.indexOf('auctionzone')!=-1){
                next('/admin/login')
            }else{
                if(Number(arr[1]) && arr[1].length == 8 && arr[2].indexOf('n')!=-1 && arr[2].indexOf('html')!=-1){
                    next('/404')
                }else{
                    next()
                }
            }
        }

    })
    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })
    return { app, router, store }
}

